export const TOAST_CHANGE_SUCCESS = 'TOAST_CHANGE_SUCCESS'
export const TOAST_CHANGE_WARNING = 'TOAST_CHANGE_WARNING'
export const TOAST_CHANGE_ERRROR = 'TOAST_CHANGE_ERRROR'
export const TOAST_CHANGE_INFO = 'TOAST_CHANGE_INFO'
export const TOAST_RESET = 'TOAST_RESET'
